export enum Environment {
  LOCAL = 'local',
  DEVELOP = 'develop',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

export const GLOBAL_DOMAIN = '.mercuryholidays.co.uk';
